module.exports = __webpack_public_path__ + "static/media/incoming_call_ringtone.8b15ec6d.mp3";